import React from 'react'

import { Suggestion } from './types'

export function SuggestionComponent(suggestion: Suggestion) {
  return <span>{suggestion.label}</span>
}
